import clsx from 'clsx';
import React, { ReactNode } from 'react';

import { Gap, Gutter, Text } from '@common/components';
import { DetailItemAttachmentType } from '@onboarding/graphql';
import { Colors } from '@common/tokens';
import { FilesCardItem } from './_files-card-item';

export const FilesCard = ({
  title,
  titleIcon,
  customHeader,
  attachedFiles,
  className,
  deleteLoading = false,
  onEdit,
  onDelete,
}: {
  title?: string;
  titleIcon?: ReactNode;
  customHeader?: ReactNode;
  className?: string;
  attachedFiles: DetailItemAttachmentType[];
  hideTimezone?: boolean;
  deleteLoading?: boolean;
  onEdit?: (attachmentId: string) => void;
  onDelete?: (attachmentId: string) => void;
}) => {
  return (
    <div className={clsx('wk-file-card', className)}>
      {title && (
        <Gutter direction="vertical" internal>
          <Gutter direction="horizontal" size="md" internal>
            <Gap align="stretch">
              {titleIcon}
              <Text align="left">{title}</Text>
            </Gap>
          </Gutter>
        </Gutter>
      )}

      {customHeader}

      {attachedFiles.map((attachment) => (
        <FilesCardItem
          key={`attachment-${attachment.id}`}
          attachment={attachment}
          className="wk-file-card__item"
          deleteLoading={deleteLoading}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}

      <style jsx>{`
        .wk-file-card {
          display: flex;
          flex-direction: column;
          align-self: stretch;
          border-radius: 0.25rem;
          border: 1px solid ${Colors.steel};
        }
        .wk-file-card :global(.wk-file-card__item) {
          border-top: 1px solid ${Colors.steel};
        }
        .wk-file-card :global(.wk-file-card__item:first-child) {
          border: none;
        }
      `}</style>
    </div>
  );
};
